export const headerHeight = '106px';
export const headerTopHeight = '40px';
export const footerTopMargin = '200px';
export const footerHeight = '312px';
export const layoutMaxWidth = '1200px';
export const layoutPadding = '0 16px';
